// hooks/web-push/useWebPush.ts
"use client";

import { useEffect } from "react";
import { registerCurrentPublicKey } from "../../services/crypto/deviceKeyApi";
import { onForegroundMessage } from "../../lib/firebase/firebaseClient";

export default function useWebPush(userId?: number) {
  useEffect(() => {
    if (!userId) return;

    async function register() {
      try {
        // Register both: public key + push token
        await registerCurrentPublicKey(false, false);
      } catch (err) {
      }
    }

    register();

    // Enable foreground notifications
    onForegroundMessage((payload) => {

    });

  }, [userId]);
}
